import { isBefore, isAfter } from "date-fns";

const ReservationBuilderHelper = {
  taken_room_ids: (reservation_segments, check_in_date, check_out_date) => {
    return reservation_segments.reduce((results, seg) => {
      if (
        isBefore(new Date(seg.check_in_date), new Date(check_out_date)) &&
        isAfter(new Date(seg.check_out_date), new Date(check_in_date))
      ) {
        if (typeof seg.room_id === "string" && seg.room_id != "") {
          results.push(seg.room_id);
        } else if (
          typeof seg.room_group_id === "string" &&
          seg.room_group_id != ""
        ) {
          results.push(seg.room_group_id);
        }
      }
      return results;
    }, []);
  },

  taken_room_types: (
    reservation_segments,
    check_in_date,
    check_out_date,
    room_ids = []
  ) => {
    return reservation_segments.reduce((acc, segment) => {
      if (
        isBefore(new Date(segment.check_in_date), new Date(check_out_date)) &&
        isAfter(new Date(segment.check_out_date), new Date(check_in_date)) &&
        !room_ids.includes(segment.room_id) &&
        !room_ids.includes(segment.room_group_id)
      ) {
        if (acc[segment.room_type.id]) {
          acc[segment.room_type.id] += 1;
        } else {
          acc[segment.room_type.id] = 1;
        }
      }

      return acc;
    }, {});
  },

  taken_room_types_and_ids: (
    reservation_segments,
    check_in_date,
    check_out_date
  ) => {
    const room_ids = ReservationBuilderHelper.taken_room_ids(
      reservation_segments,
      check_in_date,
      check_out_date
    );
    const room_types = ReservationBuilderHelper.taken_room_types(
      reservation_segments,
      check_in_date,
      check_out_date,
      room_ids
    );
    return [room_types, room_ids];
  },
};

export default ReservationBuilderHelper;
